import { render, staticRenderFns } from "./Pcview.vue?vue&type=template&id=5d76f6b6&scoped=true&"
import script from "./Pcview.vue?vue&type=script&lang=js&"
export * from "./Pcview.vue?vue&type=script&lang=js&"
import style0 from "./Pcview.vue?vue&type=style&index=0&id=5d76f6b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d76f6b6",
  null
  
)

export default component.exports